export default {
    LOAD_CAMPAIGN(state, campaign) {
        state.items = campaign;
    }
}